"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSNonPrimaryMessageComponent = void 0;
const generic_content_service_1 = require("../../services/generic-content.service");
class CSNonPrimaryMessageComponent {
    constructor(genericContentService) {
        this.genericContentService = genericContentService;
    }
    ngOnInit() {
        this.getGenericContentText();
    }
    getGenericContentText() {
        const contents = [
            'genericContentNonprimaryProfile',
            'genericContentNonprimaryProfilePrimaryAccountLinked'
        ];
        this.genericContentService.getBulkGenericContent(contents).subscribe((data) => {
            for (const content of data) {
                if (content.id === 'genericContentNonprimaryProfile' && this.isPresentPrimary) {
                    this.nonPrimaryProfileUser = content.content;
                }
                if (content.id === 'genericContentNonprimaryProfilePrimaryAccountLinked' && !this.isPresentPrimary) {
                    this.nonPrimaryProfileUser = content.content;
                }
            }
        }, (err) => {
            this.error = err;
        });
    }
}
exports.CSNonPrimaryMessageComponent = CSNonPrimaryMessageComponent;
//# sourceMappingURL=nonprimarymessage.component.js.map